import tippy  from 'tippy.js'

export function tooltip(selectors) {
    selectors.forEach(item => tippy(item, {content: item.dataset['tippy-content']}))
}
